import React, { useRef } from 'react';
import { PrinterDependencyInversionContext } from './context';

export const PrinterDependencyInversion = ({ children }: React.PropsWithChildren<{}>) => {
  const emailExecutor = useRef(null);
  const printExecutor = useRef(null);

  const contextValue = React.useMemo(() => ({
    email: emailExecutor,
    print: printExecutor,
  }), [emailExecutor, printExecutor]);

  return (
    <PrinterDependencyInversionContext.Provider value={contextValue}>
      {children}
    </PrinterDependencyInversionContext.Provider>
  );
};
